if (!customElements.get('benefit-tabs')) {
  customElements.define('benefit-tabs', class BenefitTabs extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.tablist.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      }, { signal });

      this.tablist.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

      this.addEventListener('shopify:block:select', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.target.closest('[role="tab"]'));
      if (currentIndex === -1) return;

      const lastIndex = this.tabs.length - 1;
      const nextIndex = {
        ArrowRight: currentIndex === lastIndex ? 0 : currentIndex + 1,
        ArrowLeft: currentIndex === 0 ? lastIndex : currentIndex - 1,
        Home: 0,
        End: lastIndex,
      }[event.key];
      if (nextIndex === undefined) return;

      event.preventDefault();
      this.select(nextIndex, { focus: true });
    }

    select(index, { focus = false } = {}) {
      if (index < 0 || index >= this.tabs.length) return;

      this.tabs.forEach((tab, tabIndex) => {
        const isSelected = tabIndex === index;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
        if (this.panels[tabIndex]) this.panels[tabIndex].hidden = !isSelected;
      });

      const selectedTab = this.tabs[index];
      if (focus) selectedTab.focus({ preventScroll: true });
      this.scrollTabIntoView(selectedTab);
    }

    scrollTabIntoView(tab) {
      const { scrollLeft, clientWidth } = this.tablist;
      const tabStart = tab.offsetLeft;
      const tabEnd = tabStart + tab.offsetWidth;
      let left = null;

      if (tabStart < scrollLeft) left = tabStart;
      else if (tabEnd > scrollLeft + clientWidth) left = tabEnd - clientWidth;
      if (left === null) return;

      this.tablist.scrollTo({ left, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
  });
}
